/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from '../models/User';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Add a user
     * @param requestBody
     * @returns any Successfully added a user
     * @throws ApiError
     */
    public static postUser(
        requestBody: {
            invitation_id: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a user
     * @param workspaceId The workspace_id of user to get or delete
     * @param id The id of user to delete
     * @returns any Successfully deleted user
     * @throws ApiError
     */
    public static deleteUser(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List of users of user
     * @param workspaceId The workspace_id of user to get or delete
     * @param limit How many elements you want to fetch
     * @param offset offset from where you want to start the list
     * @returns any Successfully retrieved list of users
     * @throws ApiError
     */
    public static getUserList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<{
        items?: Array<User>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Send an invitation
     * @param workspaceId Workspace ID required
     * @param requestBody
     * @returns any Successfully added a user
     * @throws ApiError
     */
    public static postUserInvite(
        workspaceId: string,
        requestBody: {
            email: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/invite',
            query: {
                'workspace_id': workspaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal server error`,
            },
        });
    }
    /**
     * Delete a invitation
     * @param workspaceId The workspace_id of user to get or delete
     * @param id The id of user to delete
     * @returns any Successfully deleted user
     * @throws ApiError
     */
    public static deleteUserInvite(
        workspaceId: string,
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user/invite/{id}',
            path: {
                'id': id,
            },
            query: {
                'workspace_id': workspaceId,
            },
            errors: {
                404: `User not found`,
                500: `Internal server error`,
            },
        });
    }
    /**
     * List user invitations
     * @param workspaceId The workspace_id of user to get or delete
     * @param limit How many elements you want to fetch
     * @param offset offset from where you want to start the list
     * @returns any Successfully retrieved list of users
     * @throws ApiError
     */
    public static getUserInviteList(
        workspaceId: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<{
        items?: Array<User>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/invite/list',
            query: {
                'workspace_id': workspaceId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
